import * as z from "zod/v4";
import { MoneySchema, WeightSchema } from "../outbound-labels/util";
import { RedoFulfillmentLocationSchema } from "./fulfillment-location";
import { FulfillmentOrderAddressSchema } from "./fulfillment-order-address";
import { FulfillmentOrderLineItemSchema } from "./fulfillment-order-line-item";

export const CreateFulfillmentOrderSchema = z.object({
  location: RedoFulfillmentLocationSchema.nullish(),
  address: FulfillmentOrderAddressSchema,
  billingAddress: FulfillmentOrderAddressSchema.nullish(),
  orderInfo: z.object({
    orderNumber: z.string(),
    secondaryOrderName: z.string().nullish(),
    orderDate: z.date(),
    paidDate: z.date(),
    shippingPaid: MoneySchema,
    taxPaid: MoneySchema,
    totalPaid: MoneySchema,
    items: z.array(FulfillmentOrderLineItemSchema),
    internalNote: z.string(),
    orderNote: z.string().optional(),
    noteToBuyer: z.string().optional(),
    tags: z.array(z.string()).nullish(),
  }),
  customer: z
    .object({ email: z.string().nullish(), name: z.string().nullish() })
    .nullish(),
  fulfillBy: z.date().nullish(),
  requestedShippingService: z.string().nullish(),
  weight: WeightSchema.nullish(),
  salesChannel: z.string().nullish(),
  redoOrderId: z.string().nullish(),
  orderId: z.string().nullish(),
});

export type CreateFulfillmentOrder = z.infer<
  typeof CreateFulfillmentOrderSchema
>;
export interface ICreateFulfillmentOrder
  extends z.ZodType<CreateFulfillmentOrder> {}
